export default [
  // {
  //   path: '/service-system',
  //   name: 'list-service-system',
  //   component: () => import('@/views/serviceSystem1/List.vue'),
  //   meta: {
  //     pageTitle: 'breadcrumb.serviceSystem',
  //     navActiveLink: 'list-service-system',
  //     resource: 'manage-service-system',
  //     action: 'read',
  //     breadcrumb: [
  //       {
  //         text: 'breadcrumb.listServiceSystem',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/service-system/:id/update',
  //   name: 'update-service-system',
  //   component: () => import('@/views/serviceSystem/Update.vue'),
  //   meta: {
  //     pageTitle: 'breadcrumb.serviceSystem',
  //     navActiveLink: 'list-service-system',
  //     resource: 'manage-service-system',
  //     action: 'update',
  //     breadcrumb: [
  //       {
  //         text: 'breadcrumb.listServiceSystem',
  //         to: { name: 'list-service-system' },
  //       },
  //       {
  //         text: 'breadcrumb.updateServiceSystem',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/service-system/:id/detail',
  //   name: 'detail-service-system',
  //   component: () => import('@/views/serviceSystem/Detail.vue'),
  //   meta: {
  //     pageTitle: 'breadcrumb.serviceSystem',
  //     navActiveLink: 'list-service-system',
  //     resource: 'manage-service-system',
  //     action: 'view',
  //     breadcrumb: [
  //       {
  //         text: 'breadcrumb.listServiceSystem',
  //         to: { name: 'list-service-system' },
  //       },
  //       {
  //         text: 'breadcrumb.detailServiceSystem',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
]
